export enum CountryId {
  MEXICO = 'MX',
  CHILE = 'CL',
}
